import { ActivityEntityName, EntityQueueType } from '@jms/model';

export const SETUP_STEP_ID = 'setup';
export const FLAG_JOB_STEP_ID = 'flag-job';
export const FLAG_STAGE_STEP_ID = 'flag-stage';
export const ENTITY_JOB_STEP_ID = 'entity-job';
export const ENTITY_STAGE_STEP_ID = 'entity-stage';
export const ENTITY_INVOICE_STEP_ID = 'entity-invoice';
export const ENTITY_BILL_STEP_ID = 'entity-bill';

const ENTITY_STEP_IDS: Partial<Record<ActivityEntityName, string>> = {
  [ActivityEntityName.Job]: ENTITY_JOB_STEP_ID,
  [ActivityEntityName.WorkOrder]: ENTITY_STAGE_STEP_ID,
  [ActivityEntityName.JobStages]: ENTITY_STAGE_STEP_ID,
  [ActivityEntityName.Invoice]: ENTITY_INVOICE_STEP_ID,
  [ActivityEntityName.Bill]: ENTITY_BILL_STEP_ID,
};

/** The wizard step that configures a queue of `type` on `entity`. Setup refuses unsupported pairings (isAllowedEntityQueueTarget). */
export function resolveStep2Id(type: EntityQueueType | undefined, entity: ActivityEntityName | undefined): string {

  if (type === EntityQueueType.Entity) return ENTITY_STEP_IDS[entity] ?? ENTITY_JOB_STEP_ID;
  return entity === ActivityEntityName.WorkOrder || entity === ActivityEntityName.JobStages ? FLAG_STAGE_STEP_ID : FLAG_JOB_STEP_ID;
}
